import { departmentsApi } from '../admin.api';
import ResourceManager, { ResourceColumn, ResourceField } from '../components/ResourceManager';

const columns: ResourceColumn[] = [
  { id: 'id', dataKey: 'id', label: 'ID', align: 'center', sortable: true },
  { id: 'name', dataKey: 'name', label: 'Department', align: 'left', sortable: true },
  { id: 'description', dataKey: 'description', label: 'Description', align: 'left' },
];

const fields: ResourceField[] = [
  { name: 'name', label: 'Department Name', required: true },
  { name: 'description', label: 'Description', type: 'textarea' },
];

export default function DepartmentsPage() {
  return (
    <ResourceManager
      title='DEPARTMENTS'
      entityName='Department'
      client={departmentsApi}
      columns={columns}
      fields={fields}
    />
  );
}
